import React from 'react';
import { TileInfo } from 'app/home/index.functions';
import { UserAuth } from 'store/auth';
import { TileEdit } from './TileEdit';

export const TileEditLine = function ({
    style,
    src,
    tile,
    tileicons,
    userauth,
}: {
    style?: any;
    src?: string;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
    userauth: UserAuth;
}) {
    let defaultStyle = {};
    return <TileEdit tile={tile} tileicons={tileicons} userauth={userauth} style={style} defaultStyle={defaultStyle} />;
};
